import styled from 'styled-components';

export const Tag = styled.div``;

export const TitleContainer = styled.div`
  width: 100%;
  background: #f3f3f3;
  padding: 24px 24px 16px 24px;
  border-bottom: solid 1px #d7d7d8;

  span {
    color: #383a3f;
  }
`;

export const HeaderContainer = styled.div`
  padding: 24px;
  display: flex;
  background: white;
  align-items: center;
  justify-content: space-between;

  span {
    color: #6f7074;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;

  i {
    color: #bbbbbd;
  }

  & > div:last-child {
    width: 225px;
    border: 1px solid #c3c4c5;
  }
`;

export const Filter = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;
  padding-right: 24px;
  border-right: solid 1px #d7d7d8;

  span {
    color: #a3A4A6;
  }
`;
